/**
 * 結果ステータス
 */
const ResultStatusCode = {
  /** 正常終了 */
  SUCCESS: 0,
  /** エラー */
  ERROR: -1,
} as const;

type ResultStatusCode = typeof ResultStatusCode[keyof typeof ResultStatusCode];
export default ResultStatusCode;
